import * as React from "react";
import { SingleAdRequestOperation } from "../../../../../../__generated__/api";
import Marquees = SingleAdRequestOperation.Marquees;
import Portal from "components/flexComponents/SponsoredContentRenderer/portal";
import { ReactPortal } from "react";

const _getMarqueePortal = (sponsoredContentId: string, data: Object): ReactPortal =>
  (
    <Portal sponsoredContentId={sponsoredContentId} key={sponsoredContentId}>
      <meso-native-marquee-gallery-tile adId={sponsoredContentId}>
        <meso-model hidden={true}>{JSON.stringify(data)}</meso-model>
      </meso-native-marquee-gallery-tile>
    </Portal>
  ) as ReactPortal;

const getMarqueePortals = (marquees: Marquees[]): ReactPortal[] | null => {
  if (!marquees || marquees.length !== 3) {
    return null;
  }
  const portals: ReactPortal[] = [];
  marquees.forEach((tile, index) => {
    const marqueePortal = _getMarqueePortal(`NMC${index + 1}`, tile);
    if (marqueePortal) {
      portals.push(marqueePortal);
    }
  });

  return portals;
};

export default {
  getMarqueePortals,
  _getMarqueePortal,
};
